import { Turnstile } from '@marsidev/react-turnstile';
import type { TurnstileInstance, TurnstileProps } from '@marsidev/react-turnstile';

import { getTurnstileSitekey } from '@shared/configs/configs/config';

interface ITurnstileWrapperProps extends Omit<TurnstileProps, 'siteKey'> {
  onError?: (error: string) => void;
  onSuccess?: (token: string) => void;
  setTurnstileToken: React.Dispatch<React.SetStateAction<string | undefined>>;
  turnstileRef: React.RefObject<TurnstileInstance>;
}

const TurnstileWrapper = ({
  turnstileRef,
  setTurnstileToken,
  onSuccess,
  onError,
  ...turnstileProps
}: ITurnstileWrapperProps) => {
  const handleError = (error: string) => {
    setTurnstileToken(undefined);
    onError?.(error);
  };

  const handleSuccess = (token: string) => {
    setTurnstileToken(token);
    onSuccess?.(token);
  };

  return (
    <Turnstile
      {...turnstileProps}
      onError={handleError}
      onSuccess={handleSuccess}
      ref={turnstileRef}
      siteKey={getTurnstileSitekey()}
    />
  );
};

export default TurnstileWrapper;
